module.exports = "/assets/2d7bde7bd47be09ddcb610c82ffb6720.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OV.png
// module id = 1694
// module chunks = 0